import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-800 text-background-200">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Brand */}
            <div>
              <h4 className="font-heading text-xl text-background-50 mb-3">吹雪漫画网</h4>
              <p className="text-sm text-background-400 leading-relaxed">
                免费无删减漫画在线阅读平台，提供下拉式流畅阅读体验。每日更新热门漫画，海量资源任您畅读。
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-medium text-background-50 mb-3">快速链接</h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/category/all" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                    分类浏览
                  </Link>
                </li>
                <li>
                  <Link to="/article/dongdong-zahuopu" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                    洞洞杂货铺
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            {/* Hot Categories */}
            <div>
              <h4 className="font-medium text-background-50 mb-3">热门分类</h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link to="/category/rexue" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                    热血漫画
                  </Link>
                </li>
                <li>
                  <Link to="/category/qihuan" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                    奇幻漫画
                  </Link>
                </li>
                <li>
                  <Link to="/category/aiqing" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                    恋爱漫画
                  </Link>
                </li>
                <li>
                  <Link to="/category/xuanhuan" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                    玄幻漫画
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-medium text-background-50 mb-3">联系我们</h4>
              <ul className="flex flex-col gap-2">
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-mail-line text-base w-4 h-4 flex items-center justify-center"></i>
                  <span>service@chuixue.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-customer-service-2-line text-base w-4 h-4 flex items-center justify-center"></i>
                  <span>在线客服：工作日 9:00-18:00</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-map-pin-line text-base w-4 h-4 flex items-center justify-center"></i>
                  <span>中国·北京</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2026 吹雪漫画网 Chuixue.com - 免费无删减漫画在线阅读平台
            </p>
            <div className="flex items-center gap-4">
              <a href="/about" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap">
                隐私政策
              </a>
              <a href="/about" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap">
                服务条款
              </a>
              <a href="/about" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}